type TCheckoutValidationFailureCode =
  | 'NO_GUEST_NAME_OR_EMAIL'
  | 'NO_NEW_ADDRESS_DETAILS_ENTERED' // User did not enter new address details
  | 'NO_NEW_CARD_DETAILS_ENTERED' // User did not enter new card details
  | 'NO_SELECTED_ADDRESS' // User did not select an existing address
  | 'NO_SELECTED_CARD'; // User did not select an existing card

type ICheckoutValidationFailureReason = {
  code: TCheckoutValidationFailureCode;
  reason: string;
};

export const CheckoutValidationFailure: Record<
  TCheckoutValidationFailureCode,
  ICheckoutValidationFailureReason
> = {
  NO_NEW_ADDRESS_DETAILS_ENTERED: {
    code: 'NO_NEW_ADDRESS_DETAILS_ENTERED',
    reason: 'Please complete all delivery address details fields.',
  },
  NO_NEW_CARD_DETAILS_ENTERED: {
    code: 'NO_NEW_CARD_DETAILS_ENTERED',
    reason: 'Please complete all billing details fields.',
  },
  NO_SELECTED_ADDRESS: {
    code: 'NO_SELECTED_ADDRESS',
    reason:
      'Please select a saved address, or provide a full address and telephone number for delivery.',
  },
  NO_SELECTED_CARD: {
    code: 'NO_SELECTED_CARD',
    reason: 'You must select an existing card, or add a new one.',
  },
  NO_GUEST_NAME_OR_EMAIL: {
    code: 'NO_GUEST_NAME_OR_EMAIL',
    reason: 'Please enter your name and email address.',
  },
};

type IValidateAuthedOrderResultReason = {
  code: TCheckoutValidationFailureCode;
  reason: string;
};

export type TValidateAuthedOrderResultAffectedFields =
  | 'CARD_DISPLAY_NAME'
  | 'DELIVERY_DISPLAY_NAME'
  | 'DELIVERY_PHONE_NUMBER'
  | 'DELIVERY_POSTCODE'
  | 'DELIVERY_RECIPIENT_NAME'
  | 'DELIVERY_STREET'
  | 'DELIVERY_TOWN'
  | 'GUEST_CHECKOUT_EMAIL'
  | 'GUEST_CHECKOUT_NAME'
  | 'PAYMENT_CARDHOLDER_NAME'
  | 'PAYMENT_CARDHOLDER_POSTCODE'
  | 'PAYMENT_CARDHOLDER_STREET'
  | 'PAYMENT_CARDHOLDER_TOWN'
  | undefined;

export type IValidateAuthedOrderResult = {
  result: boolean;
  reason?: IValidateAuthedOrderResultReason;
  affectedFields?: TValidateAuthedOrderResultAffectedFields[];
};
